import {useIntl} from 'react-intl'
import {AddManagementTeamBreadCrum} from '../core/_constants'
import {PageTitle} from '../../../../../_metronic/layout/core'
import { AddTeamMemberForm } from '../components/add-team-member-form'

export const AddTeamMember = () => {
  const {formatMessage} = useIntl()
  return (
    <>
      <PageTitle
        breadcrumbs={AddManagementTeamBreadCrum}
        description={formatMessage({id: 'Add Team Member'})}
      >
        {formatMessage({id: 'Add Team Member'})}
      </PageTitle>

      <div className='my-auto w-100'>
        <AddTeamMemberForm />
      </div>
    </>
  )
}
